<template>
  <div class="modal" id="modal_kids">
    <div class="content">
      <h2 class="content-title">{{$t('kidsSection.title')}}</h2>
      <p class="content-description">{{$t('kidsModal.p1')}}</p>
      <p class="content-description">{{$t('kidsModal.p2')}}</p>
      <p class="content-description">{{$t('kidsModal.p3')}}</p>
      <ul>
        <li>{{$t('kidsModal.p4')}}</li>
        <li>{{$t('kidsModal.p5')}}</li>
        <li>{{$t('kidsModal.p6')}}</li>
      </ul>
      <p class="content-description">{{$t('kidsModal.p7')}}</p>
      <p class="content-description">{{$t('kidsModal.p8')}}</p>
      <p class="content-description">{{$t('kidsModal.p9')}}</p>
    </div>
  </div>

</template>

<script>
import {showAt, hideAt} from 'vue-breakpoints'

export default {
  name: 'KidsModal',
  components: {hideAt, showAt},
  computed: {
    lang: function () {
      return this.$root.locale;
    }
  }
}
</script>
